import { validateFormat } from 'ember-changeset-validations/validators';

export const InvitationValidation = {
  email: [validateFormat({ type: 'email' })],
};
